import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import Stream from 'flarum/common/utils/Stream';

import VisibilitySelector from './VisibilitySelector';

export default class VisibilityModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.discussion = this.attrs.discussion;
    this.isPrivate = Stream(this.discussion.isPrivate());
  }

  className() {
    return 'VisibilityModal Modal--small';
  }

  title() {
    return app.translator.trans('jcswa-discussion-visibility.forum.visibility_modal.title');
  }

  content() {
    return (
      <div className="Modal-body">
        <div className="Form Form--centered">
          <div className="Form-group">
            <VisibilitySelector isPrivate={this.isPrivate()} onchange={(isPrivate) => this.isPrivate(isPrivate)} />
          </div>
          <div className="Form-group">
            <Button className="Button Button--primary Button--block" type="submit" loading={this.loading}>
              {app.translator.trans('jcswa-discussion-visibility.forum.visibility_modal.submit_button')}
            </Button>
          </div>
        </div>
      </div>
    );
  }

  onsubmit(event) {
    event.preventDefault();

    this.loading = true;

    return this.discussion
      .save({ isPrivate: this.isPrivate() })
      .then(() => {
        app.discussions.refresh();
        this.hide();
        m.redraw();
      })
      .catch(() => {
        this.loading = false;
        m.redraw();
      });
  }
}
